module.exports = __webpack_public_path__ + "static/img/3.617df45.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/3.png
// module id = 281
// module chunks = 0